import { ResourceModel } from '@bryntum/schedulerpro';

export class GroupByProjectResourceModel extends ResourceModel {
  static get fields() {
    return [
      { name: 'type', type: 'string' },
      { name: 'projectName', type: 'string' },
      { name: 'projectId', type: 'number' },
      { name: 'customer', type: 'object' },
      { name: 'budgetedHours', type: 'number' },
      { name: 'totalAllocation', type: 'number' },
      { name: 'roleName', type: 'string' },
      { name: 'projectId', type: 'number' },
      { name: 'firstName', type: 'string' },
      { name: 'userId', type: 'number' },
      { name: 'lastName', type: 'string' },
      { name: 'photoUrl', type: 'string' },
      { name: 'role', type: 'object' },
      { name: 'isProjectOwner', type: 'boolean' },
      { name: 'teamName', type: 'string' },
      { name: 'teamId', type: 'number' },
      { name: 'roleId', type: 'number' },
      { name: 'referenceTeam', type: 'object' },
      { name: 'status', type: 'object' },
      { name: 'startDate', type: 'string' },
      { name: 'dueDate', type: 'string' },
      { name: 'budgetedHoursRange', type: 'object' },
      { name: 'dataLoading', type: 'boolean' },
      { name: 'readOnly', type: 'boolean' },
      { name: 'autoAllocation', type: 'boolean' },
      { name: 'company', type: 'object' },
      { name: 'userType', type: 'string' },
      { name: 'userStatus', type: 'string' },
      { name: 'userList', type: 'object' },
      { name: 'companyList', type: 'object' },
      { name: 'rbacType', type: 'string' },
      { name: 'otherUserIds', type: 'object' },
    ];
  }
}
